export default "__VITE_ASSET__B4iYv59O__"